export const UNUSED_ACTION_TYPE = 'UNUSED_ACTION_TYPE';
